import { BOARD_TYPES } from "Boards/const";

import { deepEqual } from "Utilities/deepEqual";

export function showSaveDefaultFiltersButton({
  savedBoardFilter,
  disabled,
  activeFiltersHaveChanged,
  boardType,
}) {
  let show = false;

  const isSignupBoard = boardType === BOARD_TYPES.SIGNUP;

  let activeFilter =
    window.fnReactBus?.filtersPanel?.filterBuilder?.buildRequest()?.and?.[0]
      ?.or?.[0]?.and;

  const savedFilters = convertSavedBoardFiltersInputs(savedBoardFilter);

  const activeAndSavedFiltersEqual = deepEqual(activeFilter, savedFilters);

  if (disabled) {
    show = false;
  } else if (isSignupBoard) {
    show = false;
  } else if (!activeFilter && !savedFilters) {
    show = false;
  } else if (activeFilter && !savedFilters) {
    show = true;
  } else if (activeAndSavedFiltersEqual) {
    show = false;
  } else if (!activeFilter && savedFilters && activeFiltersHaveChanged) {
    show = true;
  } else {
    show = true;
  }

  return { show };
}

function convertSavedBoardFiltersInputs(savedBoardFilter) {
  const savedFilters = savedBoardFilter?.filters?.and?.[0]?.or?.[0]?.and;
  const convertedFilters = savedFilters?.map((filter) => {
    const inputIsEmptyArray =
      Array.isArray(filter?.inputs) && filter.inputs.length === 0;

    return {
      ...filter,
      inputs: inputIsEmptyArray ? {} : filter.inputs,
    };
  });
  return convertedFilters;
}
